import { useQuery, useMutation, useQueryClient } from 'react-query';
import * as apiKeysApi from '../api/apiKeys';
import { CreateApiKeyData } from '../api/apiKeys';

export const apiKeysKey = ['apiKeys'] as const;
export const apiKeyScopesKey = ['apiKeyScopes'] as const;

export const useApiKeys = (includeRevoked?: boolean) => {
    return useQuery({
        queryKey: [...apiKeysKey, { includeRevoked }],
        queryFn: () => apiKeysApi.getApiKeys(includeRevoked),
    });
};

/**
 * The scopes this organization may currently be granted.
 *
 * A separate key from `apiKeysKey` on purpose: creating or revoking a key does not change which
 * scopes are on offer, so this must not be invalidated by those mutations. It changes only when a
 * feature flag is flipped or a new route ships, neither of which the client can observe.
 */
export const useApiKeyScopes = () => {
    return useQuery({
        queryKey: apiKeyScopesKey,
        queryFn: () => apiKeysApi.getApiKeyScopes(),
    });
};

export const useCreateApiKey = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CreateApiKeyData) => apiKeysApi.createApiKey(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: apiKeysKey });
        },
    });
};

export const useRevokeApiKey = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (apiKeyId: number) => apiKeysApi.revokeApiKey(apiKeyId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: apiKeysKey });
        },
    });
};
